import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { toast } from "react-toastify";
import { FaCheck } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import { LOCALES } from "common/constants";

const options = [
  { value: "invozio", label: "Invozio" },
  { value: "frilans-finans", label: "Frilans Finans" },
  { value: "cool-company", label: "Cool Company" },
];
const companyReviewOptions = [
  { value: "invozio", label: "Invozio" },
  { value: "frilans-finans", label: "Frilans Finans" },
  { value: "cool-company", label: "Cool Company" },
  { value: "gigger", label: "Gigger" },
];

const colourStyles = {
  option: (styles, { isDisabled, isSelected }) => ({
    ...styles,
    backgroundColor: isSelected ? "#c4b7f7" : "white",
    color: "#535353",
    cursor: isDisabled ? "not-allowed" : "default",
    ":active": {
      backgroundColor: "#c4b7f7",
      color: "white",
    },
    ":hover": {
      backgroundColor: "#9e8ce8",
      color: "white",
    },
  }),
};

const options2 = [
  {
    value: "/frilans-finans-vs-Invozio",
    label: "Frilans Finans",
    to: "/frilans-finans-vs-Invozio",
  },
  {
    value: "/cool-company-vs-Invozio",
    label: "Cool Company",
    to: "/cool-company-vs-Invozio",
  },
  { value: "/gigger-vs-Invozio", label: "Gigger", to: "/gigger-vs-Invozio" },
];

export const ComparisonTable = () => {
  const { t } = useTranslation();

  const [spinner, setShowSpinner] = useState(false);
  const [selectedComparisonOption, setSelectedComparisonOption] =
    useState("invozio");
  const { reset } = useForm();
  const navigate = useNavigate();
  const location = useLocation();
  let language = localStorage.getItem("i18nextLng");

  const [tableAmountValue, setTableAmountValue] = useState("");

  const [tableAmount, setTableAmount] = useState({
    giggerCharges: 0,
    fakturaCharges: 0,
    tableAmount: (1000000).toLocaleString(LOCALES.EN_US), 
    coolComapanyCharges: 0,
    frilansFinansCharges: 0,
  });

  useEffect(() => {
    if (tableAmountValue) {
      const timer = setTimeout(async () => {
        try {
          if (
            tableAmountValue?.startsWith(",") ||
            tableAmountValue?.startsWith("0")
          )
            return;

          setShowSpinner(true);
          const response = await axios.get(
            `/calculator?amount=${tableAmountValue ? tableAmountValue : 0}`
          );
          if (response?.status === 200) {
            const {
              fakturaCharges,
              coolComapanyCharges,
              frilansFinansCharges,
              giggerCharges,
            } = response?.data?.response;

            setTableAmount({
              ...tableAmount,
              fakturaCharges: fakturaCharges,
              coolComapanyCharges: coolComapanyCharges,
              frilansFinansCharges: frilansFinansCharges,
              giggerCharges: giggerCharges,
            });

            let formated = (tableAmountValue || 0).toLocaleString("ru");
            let unformated = parseInt(formated.replace(/,/g, ""));
            reset({
              tableAmount: Number(unformated).toLocaleString(LOCALES.EN_US), 
            });
            setShowSpinner(false);
          }
        } catch (error) {
          if (error?.response?.data) {
            toast.error(t(error?.response?.data?.message));
          } else {
            toast.error(t(error?.message));
          }
        } finally {
          setShowSpinner(false);
        }
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [tableAmountValue]);

  return (
    <>
      <section
        className={
          location.pathname ===
          "/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger"
            ? "fakturanu-platforms reviews pt-2"
            : "fakturanu-platforms pt-2"
        }
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="data text-center">
                <h2>
                  {location.pathname ===
                  "/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger" ? (
                    t("INVOZIO VERSUS OTHER BILLING PLATFORMS")
                  ) : (
                    <>
                      {t("INVOZIO VERSUS OTHER")} <br />
                      {t("BILLING PLATFORMS")}
                    </>
                  )}
                </h2>
              </div>

              <div
                className={
                  location.pathname ===
                  "/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger"
                    ? "table-data new_design_table review_table"
                    : "table-data new_design_table"
                }
              >
                <table>
                  <tbody>
                    <tr className="new_tr">
                      <th>
                        <h3>Platform</h3>
                      </th>
                      <th className="finans_frilancs mobile-hidden">
                        <h3>Invozio</h3>
                      </th>
                      <th className="finans_frilancs mobile-hidden">
                        <h3>Frilans Finans</h3>
                      </th>
                      <th className="finans_frilancs mobile-hidden">
                        <h3>Cool Company</h3>
                      </th>
                      {location.pathname ===
                        "/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger" && (
                        <th className="finans_frilancs mobile-hidden">
                          <h3> Gigger</h3>
                        </th>
                      )}

                      <th className="finans_frilancs desktop-hidden">
                        <Select
                          className="w-100"
                          // menuIsOpen={true}
                          options={
                            location.pathname ===
                            "/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger"
                              ? companyReviewOptions
                              : options
                          }
                          styles={colourStyles}
                          defaultValue={options[0]}
                          onChange={(selectedOption) =>
                            setSelectedComparisonOption(selectedOption.value)
                          }
                          isSearchable={false}
                        />
                      </th>
                    </tr>

                    <tr>
                      <td className="text-left">
                        <label className="d-none" htmlFor="tableAmount">
                          {t("Table Amount")}
                        </label>
                        <input
                          id="tableAmount"
                          className="Billing_amountInp new_bills"
                          type="text"
                          defaultValue={"1,000,000"}
                          // value={tableAmount?.tableAmount}
                          onChange={(e) =>
                            // handleTableAmountChange(e.target.value)
                            setTableAmountValue(e.target.value)
                          }
                          onKeyDown={(e) => {
                            // Allow only numbers, decimal point, and specific control keys
                            if (
                              !/[\d.]/.test(e.key) &&
                              ![
                                "Backspace",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                                "Delete",
                              ].includes(e.key)
                            ) {
                              e.preventDefault();
                            }
                          }}
                          required
                        />
                        {t("Invoicing per year SEK gives a fee per year")}
                      </td>

                      <td className="mobile-hidden">
                        {/* <img src={Check} alt="Check" className="mr-2" /> */}
                        {spinner ? (
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          ></div>
                        ) : tableAmount?.fakturaCharges ? (
                          tableAmount?.fakturaCharges.toLocaleString(LOCALES.EN_US) 
                        ) : (
                          "19,000"
                        )}

                        {!spinner && "SEK"}
                      </td>

                      <td className="mobile-hidden">
                        {spinner ? (
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          ></div>
                        ) : (
                          <>
                            {tableAmount?.frilansFinansCharges
                              ? tableAmount?.frilansFinansCharges.toLocaleString(
                                  LOCALES.EN_US
                                )
                              : "60,000"}
                            {!spinner && "SEK"}
                          </>
                        )}
                      </td>

                      <td className="mobile-hidden">
                        {spinner ? (
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          ></div>
                        ) : (
                          <>
                            {tableAmount?.coolComapanyCharges
                              ? tableAmount.coolComapanyCharges?.toLocaleString(
                                  LOCALES.EN_US
                                )
                              : "59,800"}
                            {!spinner && "SEK"}
                          </>
                        )}
                      </td>

                      {location.pathname ===
                        "/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger" && (
                        <td className="mobile-hidden">
                          {spinner ? (
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            ></div>
                          ) : (
                            <>
                              {tableAmount?.giggerCharges
                                ? tableAmount.giggerCharges.toLocaleString(
                                    LOCALES.EN_US
                                  )
                                : "35,000"}
                              {!spinner && "SEK"}
                            </>
                          )}
                        </td>
                      )}

                      <td className="desktop-hidden">
                        {(() => {
                          switch (selectedComparisonOption) {
                            case "invozio":
                              return (
                                <>
                                  {spinner ? (
                                    <div
                                      className="spinner-border text-primary"
                                      role="status"
                                    ></div>
                                  ) : (
                                    <>
                                      {tableAmount?.fakturaCharges
                                        ? tableAmount?.fakturaCharges.toLocaleString(
                                            LOCALES.EN_US
                                          )
                                        : "19,000"}
                                      {!spinner && "SEK"}
                                    </>
                                  )}
                                </>
                              );
                            case "frilans-finans":
                              return (
                                <>
                                  {spinner ? (
                                    <div
                                      className="spinner-border text-primary"
                                      role="status"
                                    ></div>
                                  ) : (
                                    <>
                                      <>
                                        {tableAmount?.frilansFinansCharges
                                          ? tableAmount?.frilansFinansCharges?.toLocaleString(
                                              LOCALES.EN_US
                                            )
                                          : "60,000"}
                                        {!spinner && "SEK"}
                                      </>
                                    </>
                                  )}
                                </>
                              );
                            case "cool-company":
                              return (
                                <>
                                  {spinner ? (
                                    <div
                                      className="spinner-border text-primary"
                                      role="status"
                                    ></div>
                                  ) : (
                                    <>
                                      <>
                                        {tableAmount?.coolComapanyCharges
                                          ? tableAmount.coolComapanyCharges.toLocaleString(
                                              LOCALES.EN_US
                                            )
                                          : "59,800"}
                                        {!spinner && "SEK"}
                                      </>
                                    </>
                                  )}
                                </>
                              );
                            case "gigger":
                              return (
                                <>
                                  {spinner ? (
                                    <div
                                      className="spinner-border text-primary"
                                      role="status"
                                    ></div>
                                  ) : (
                                    <>
                                      <>
                                        {tableAmount?.giggerCharges
                                          ? tableAmount?.giggerCharges.toLocaleString(
                                              LOCALES.EN_US
                                            )
                                          : "35,000"}
                                        {!spinner && "SEK"}
                                      </>
                                    </>
                                  )}
                                </>
                              );
                            default:
                              return null; // Default case
                          }
                        })()}
                      </td>
                    </tr>

                    <tr>
                      <td className="text-left">
                        {location.pathname === "/"
                          ? t("Express payment")
                          : t("Work Hours per Week: You Decide")}
                      </td>
                      <td className="desktop-hidden">
                        {location.pathname === "/" ? (
                          <div className="div_circle">
                            <FaCheck />
                          </div>
                        ) : selectedComparisonOption === "invozio" ? (
                          <div className="div_circle">
                            <FaCheck />
                          </div>
                        ) : (
                          <div className="empty_check"></div>
                        )}
                      </td>
                      <td className="mobile-hidden">
                        <div className="div_circle">
                          <FaCheck />
                        </div>
                      </td>
                      <td className="mobile-hidden">
                        {location.pathname === "/" ? (
                          <div className="div_circle">
                            <FaCheck />
                          </div>
                        ) : (
                          <div className="empty_check"></div>
                        )}
                      </td>

                      <td className="mobile-hidden">
                        {location.pathname === "/" ? (
                          <div className="div_circle">
                            <FaCheck />
                          </div>
                        ) : (
                          <div className="empty_check"></div>
                        )}
                      </td>
                      {location.pathname ===
                        "/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger" && (
                        <td className="mobile-hidden">
                          <div className="empty_check"></div>
                        </td>
                      )}
                    </tr>

                    <tr>
                      <td className="text-left">
                        {location.pathname === "/"
                          ? t("Comprehensive insurance")
                          : t("Hourly Wage: You Decide")}
                      </td>

                      <td className="desktop-hidden">
                        {location.pathname === "/" ? (
                          <div className="div_circle">
                            <FaCheck />
                          </div>
                        ) : selectedComparisonOption === "invozio" ? (
                          <div className="div_circle">
                            <FaCheck />
                          </div>
                        ) : (
                          <div className="empty_check"></div>
                        )}
                      </td>
                      <td className="mobile-hidden">
                        <div className="div_circle">
                          <FaCheck />
                        </div>
                      </td>
                      <td className="mobile-hidden">
                        {location.pathname === "/" ? (
                          <div className="div_circle">
                            <FaCheck />
                          </div>
                        ) : (
                          <div className="empty_check"></div>
                        )}
                      </td>
                      <td className="mobile-hidden">
                        {location.pathname === "/" ? (
                          <div className="div_circle">
                            <FaCheck />
                          </div>
                        ) : (
                          <div className="empty_check"></div>
                        )}
                      </td>
                      {location.pathname ===
                        "/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger" && (
                        <td className="mobile-hidden">
                          <div className="empty_check"></div>
                        </td>
                      )}
                    </tr>

                    <tr>
                      <td className="text-left">
                        {location.pathname === "/"
                          ? t("ROT and RUT invoice possibilities")
                          : t("Pension Savings: You Decide")}
                      </td>
                      <td className="desktop-hidden">
                        {location.pathname === "/" ? (
                          <div className="div_circle">
                            <FaCheck />
                          </div>
                        ) : selectedComparisonOption === "invozio" ? (
                          <div className="div_circle">
                            <FaCheck />
                          </div>
                        ) : (
                          <div className="empty_check"></div>
                        )}
                      </td>
                      <td className="mobile-hidden">
                        <div className="div_circle">
                          <FaCheck />
                        </div>
                      </td>
                      <td className="mobile-hidden">
                        {location.pathname === "/" ? (
                          <div className="div_circle">
                            <FaCheck />
                          </div>
                        ) : (
                          <div className="empty_check"></div>
                        )}
                      </td>
                      <td className="mobile-hidden">
                        {location.pathname === "/" ? (
                          <div className="div_circle">
                            <FaCheck />
                          </div>
                        ) : (
                          <div className="empty_check"></div>
                        )}
                      </td>
                      {location.pathname ===
                        "/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger" && (
                        <td className="mobile-hidden">
                          <div className="empty_check"></div>
                        </td>
                      )}
                    </tr>
                    {location.pathname === "/" && (
                      <tr>
                        <td className="text-left">
                          {t("Send collective invoice")}
                        </td>
                        <td className="desktop-hidden">
                          <div className="div_circle">
                            <FaCheck />
                          </div>
                        </td>
                        <td className="mobile-hidden">
                          <div className="div_circle">
                            <FaCheck />
                          </div>
                        </td>
                        <td className="mobile-hidden">
                          {location.pathname === "/" ? (
                            <div className="div_circle">
                              <FaCheck />
                            </div>
                          ) : (
                            <div className="empty_check"></div>
                          )}
                        </td>
                        <td className="mobile-hidden">
                          {location.pathname === "/" ? (
                            <div className="div_circle">
                              <FaCheck />
                            </div>
                          ) : (
                            <div className="empty_check"></div>
                          )}
                        </td>
                        {location.pathname ===
                          "/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger" && (
                          <td className="mobile-hidden">
                            <div className="empty_check"></div>
                          </td>
                        )}
                      </tr>
                    )}
                  </tbody>
                </table>
                <p>
                  {t(
                    "Not only the most cost-effective in the market, Invozio is the only platform that puts your freedom first, while others restrict through collective agreements."
                  )}

                  {location.pathname ===
                  "/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger" ? (
                    <div className="text-right mt-3 font-weight-bold">
                      Invozio vs
                      <button style={{ color: "#654eb8", width: "200px" }}>
                        <Select
                          // menuIsOpen={true}
                          options={options2}
                          styles={colourStyles}
                          onChange={(selectedOption) => {
                            setSelectedComparisonOption(selectedOption.value);
                              const selectedPath = options2.find((item) => item.to === selectedOption.value)?.to;
                              if (selectedPath) {
                                const langParam = `lang=${language === LOCALES.EN_US ? LOCALES.EN_US : LOCALES.SV_SE}`;
                                navigate(`${selectedPath}?${langParam}`);
                              }
                            window.scrollTo({
                              top: 0,
                              left: 0,
                              behavior: "smooth",
                            });
                          }}
                          isSearchable={false}
                        />
                      </button>
                    </div>
                  ) : (
                    <span
                      onClick={() =>
                        navigate(
                          language === LOCALES.EN_US
                            ? `/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger?lang=${LOCALES.EN_US}`
                            : `/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger?lang=${LOCALES.SV_SE}`
                        )
                      }
                    >
                      <button
                        style={{
                          color: "#654eb8",
                          textDecoration: "underline",
                        }}
                      >
                        {t("Read more")}
                        <span className="custom-span">
                          <BsArrowRight className="ml-2" />{" "}
                        </span>
                      </button>
                    </span>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
